export default "__VITE_ASSET__DOupphBh__"